import { __rest } from "tslib";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const ToggleOn = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 10 8", fill: "currentColor", width: size || "10", height: size || "8" }, props),
        React.createElement("path", { d: "M3.8 5L1.2 2.5 0 3.7 3.8 7.5 10 1.2 8.8 0z" })));
};
ToggleOn.displayName = 'ToggleOn';
export default ToggleOn;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ToggleOn.js.map